import services from "@/services/business/services";
import { loadStripe } from '@stripe/stripe-js';
import Vue from 'vue';

var store = {
    debug: false,
    state: {
        loading: true,
        adInfo: {
            id: null,
            clientName: null,
            businessName: null,
            address: null,
            phone: null,
            lineWork: null,
            website: null,
            image: null,
            fileImage: null,
            shortDescription: null,
            approved: null
        },
        user: {
            firstName: null,
            lastName: null,
            email: null,
            password: null
        },
        checkoutSession: null,
        onboardingPage: 0,
        alertMessage: null,
        alert: false,
        alertColor: 'error',
        stripe: null,
        invoices: null
    },
    async setStripe() {
        this.state.stripe = await loadStripe('pk_test_bFGW95HCBQPfLKzvRNgsXOmf00WEzPpKSz') //'pk_live_zE4ut177ucWkkDkulMBuxBdc00Lj8vXD8D');
    },
    async redirectToStripeCheckout(stripeSessionId) {
        console.log(stripeSessionId)
        const { error } = await this.state.stripe.redirectToCheckout({
            sessionId: stripeSessionId
        });
        if (error) {
            this.setErrorAlert(error.response.data.message);
        }
    },
    async signUp(user, checkoutSessionId = null) {
        if (!this.state.loading) this.state.loading = true;
        services.signUp(user, checkoutSessionId).then(response => {
            this.state.loading = false;
            this.state.checkoutSession = response.data;
            this.nextOnboardingPage();
        })
        .catch(error => {
            console.log(error);
            this.setErrorAlert(error.response.data.message);
        });
    },
    async createSpot(adInfo, checkoutSessionId) {
        if (!this.state.loading) this.state.loading = true;
        console.log(Vue.$cookies.get('csrftoken'));
        services.createSpot(adInfo, checkoutSessionId, Vue.$cookies.get('csrftoken'))
            .then(response => {
                this.setSuccessAlert(response.message);
                this.getStripeSession(checkoutSessionId, Vue.$cookies.get('csrftoken'));
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            });
    },
    async getStripeSession(checkoutSessionId, csrf) {
        services.getStripeSession(checkoutSessionId, csrf)
            .then(response => {
                this.state.loading = false;
                this.state.checkoutSession = response.data;
                this.redirectToStripeCheckout(this.state.checkoutSession.stripe_session_id);
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    async login(email, password, onOnboarding, onDashboard) {
        if (!this.state.loading) this.state.loading = true;
        services.login(email, password)
            .then(async response => {
                this.state.loading = false;

                this.state.user = response.data.user;
                window.localStorage.setItem('userEmail', this.state.user.email);
                window.localStorage.setItem('userFirst', this.state.user.first_name);
                window.localStorage.setItem('userLast', this.state.user.last_name);
                this.state.checkoutSession = response.data.checkout_session;
                this.setAdInfo(response.data.spot);

                if (this.state.adInfo.clientName) {
                    await this.setStripe();
                    this.getStripeSession(this.state.checkoutSession.id, Vue.$cookies.get('csrftoken'));
                } else if (this.state.checkoutSession) {
                    this.state.onboardingPage = 1;
                    onOnboarding();
                } else {
                    onDashboard();
                }
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            });
    },
    async logout(onSuccess) {
        services.logout()
            .then(() => {
                window.localStorage.removeItem('userEmail');
                onSuccess();
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    async completeCheckoutSession(checkoutSessionId, onComplete) {
        services.completeCheckoutSession(checkoutSessionId, Vue.$cookies.get('csrftoken'))
            .then(response => {
                this.state.checkoutSession = response.data;
                onComplete();
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    async updateAd(data) {
        services.updateAd(data, Vue.$cookies.get('csrftoken'))
            .then(response => {
                this.setSuccessAlert(response.message);
                this.setAdInfo(response.data);
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            });
    },
    async getSpot() {
        services.getSpot(Vue.$cookies.get('csrftoken'))
            .then(response => {
                this.setAdInfo(response.data);
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    async getInvoices() {
        services.getInvoices(Vue.$cookies.get('csrftoken'))
            .then(response => {
                this.setInvoices(response.data);
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    async updateAccount(email, firstName, lastName, password, newPassword, confPassword) {
        services.updateAccount(Vue.$cookies.get('csrftoken'), email, firstName, lastName, password, newPassword, confPassword)
            .then(response => {
                this.state.user = response.data;
                window.localStorage.setItem('userEmail', this.state.user.email);
                window.localStorage.setItem('userFirst', this.state.user.first_name);
                window.localStorage.setItem('userLast', this.state.user.last_name);
                this.setSuccessAlert(response.message);
            })
            .catch(error => {
                this.setErrorAlert(error.response.data.message);
            })
    },
    setAdInfo(data) {
        this.state.adInfo.clientName = data?.client_name;
        this.state.adInfo.businessName = data?.business_name;
        this.state.adInfo.address = data?.address;
        this.state.adInfo.shortDescription = data?.short_description;
        this.state.adInfo.phone = data?.phone_number;
        this.state.adInfo.website = data?.website;
        this.state.adInfo.image = data?.image;
        this.state.adInfo.lineWork = data?.line_of_work;
        this.state.adInfo.approved = data?.approved;
    },
    setUserInfo(data) {
        this.state.user = data;
    },
    setCheckoutSession(data) {
        this.state.checkoutSession = data;
    },
    setErrorAlert(message) {
        this.state.alertColor = 'error';
        this.state.alertMessage = message;
        this.state.alert = true;
    },
    setSuccessAlert(message) {
        this.state.alertColor = 'success';
        this.state.alertMessage = message;
        this.state.alert = true;
    },
    nextOnboardingPage() {
        this.state.onboardingPage += 1;
    },
    previousOnboardingPage() {
        this.state.onboardingPage -= 1;
    },
    setInvoices(data) {
        this.state.invoices = data;
    }
}

export default store;